import { CurrencyFormat } from "../../../../components/helpers";

export const convertCashOutletList = (cashOutlets) => {
  let convertedCashOutlets = [];

  if (!cashOutlets) return [];

  cashOutlets.forEach((cashOutlet, index) => {
    convertedCashOutlets.push({
      key: index + 1,
      outletID: cashOutlet.outlet_id,
      outletName: cashOutlet.outlet_name || "-",
      maxAmount: `Rp ${CurrencyFormat(cashOutlet.max) || 0}`,
      minAmount: `Rp ${CurrencyFormat(cashOutlet.min) || 0}`,
    });
  });

  return convertedCashOutlets;
};
